import { Colaborador } from '@/store/catalogos/colaborador';
import { DepartamentoModel } from '@/store/catalogos/departamento';
import { properties } from '@/utils/properties';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class CatalogoDepartamentoService {
  private readonly baseUrl = properties.URL_CATALOGOS + 'departamentos';

  constructor(private http: HttpClient) { }

  // Obtener todos los departamento 
  getAll(): Observable<DepartamentoModel[]> {
    return this.http.get<DepartamentoModel[]>(this.baseUrl, httpOptions);
  }

  // Crear un nuevo departamento
  create(departamento: DepartamentoModel): Observable<DepartamentoModel> {
    return this.http.post<DepartamentoModel>(this.baseUrl, departamento, httpOptions);
  }

  // Actualizar un departamento existente
  update(departamento: DepartamentoModel): Observable<DepartamentoModel> {
    return this.http.put<DepartamentoModel>(`${this.baseUrl}/${departamento.idArea}`, departamento, httpOptions);
  }


}
